import { render } from "./standard.vue?vue&type=template&id=3cc8a5be"
import script from "./standard.vue?vue&type=script&lang=js"
export * from "./standard.vue?vue&type=script&lang=js"

import "./standard.vue?vue&type=style&index=0&id=3cc8a5be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__